/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-200);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-200);
  --background: var(--nve-sys-layer-container-background);
  --color: var(--nve-sys-layer-canvas-color);
  --border-radius: var(--nve-ref-border-radius-lg);
  --box-shadow: var(--nve-ref-shadow-100);
  --font-size: var(--nve-ref-font-size-100);
  --row-height: var(--nve-ref-size-900);
  --scroll-height: initial;
  --grid-auto-columns: minmax(0, 1fr);
  --scroll-width: 0;
  --grid-template-column: initial;
  --grid-auto-flow: column;
  display: grid;
  contain: none;
  width: 100%; /* fallback safari */
  width: stretch;
}

[internal-host] {
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  background: var(--background);
  color: var(--color);
  font-size: var(--font-size);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  overflow: hidden;
  color-scheme: inherit;
  position: relative;
  height: 100%;
  width: 100%;
}

:host(:state(scrolling)) {
  --scroll-shadow: 0 0 4px hsl(0 0% 0% / 0.4);
}

[name='columns'] {
  min-width: fit-content;
  display: grid;
  position: sticky;
  top: 0;
  z-index: 100;
}

[part='_scrollbox'] {
  height: 100%;
  width: 100%;
  max-height: var(--scroll-height);
  min-height: var(--scroll-height);
  contain: layout;
  overflow: auto;
  position: relative;
  scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
  scrollbar-width: var(--nve-sys-scrollbar-width);
}

:host([container*='full']) {
  --border-radius: 0;
  --box-shadow: none;
}

:host([container*='flat']) {
  --border-radius: 0;
  --box-shadow: none;
  --background: inherit;
}

:host([container*='flat']) ::slotted(nve-grid-header) {
  --background: inherit;
}

:host([stripe]) ::slotted(nve-grid-row:nth-child(odd)) {
  --background: var(--nve-sys-layer-container-accent-background);
}

::slotted(nve-grid-row:last-child) {
  --border-bottom: 0;
}

::slotted(nve-toolbar) {
  position: fixed;
  z-index: 99;
  left: var(--nve-ref-size-300);
  bottom: var(--nve-ref-size-300);
  width: calc(100% - 24px);
}
